module.exports = __webpack_public_path__ + "img/20200514_api_trends_and_challenges.b65ef8c3.jpg";